module.exports = __webpack_public_path__ + "static/img/7.fd5479c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/zh/7.png
// module id = 7nAv
// module chunks = 0